export default __webpack_public_path__ + "assets/43192ff6e26d7c1d721f78ef3780f9f8.png";